import { Injectable } from '@angular/core';
import { LeaApiService } from './lea-api.service';
import { AccessPayload } from '../__models/access';

@Injectable()
export class AdminService {
    constructor(
        private _rest: LeaApiService
    ) {}

    public customerEnable(enable: boolean) {
        const payload = {
            companyName: localStorage.getItem('customer'),
            enable: enable,
        };

        return this._rest.put('dqadmin/customerEnable', payload);
    }

    public customerServices(payload: AccessPayload) {
        return this._rest.put(`dqadmin/teams/access`, payload);
    }
}
